// extracted by mini-css-extract-plugin
export default {"navigationButtons":"QuestionNavigation_navigationButtons__-gJ8O","backBtn":"QuestionNavigation_backBtn__gv+0n"};